import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import overlayStyles from './OverlayHelpers.scss';
var HoverableWrapper = React.forwardRef(function (_a, ref) {
    var isSectionBoundary = _a.isSectionBoundary, className = _a.className, __forceHoveredForStories = _a.__forceHoveredForStories, props = __rest(_a, ["isSectionBoundary", "className", "__forceHoveredForStories"]);
    var newProps = __assign(__assign({}, props), { className: classnames(overlayStyles['hoverable'], __forceHoveredForStories && overlayStyles['force-hovered'], className) });
    return isSectionBoundary ? (React.createElement(Section, __assign({}, newProps, { ref: ref }))) : (React.createElement("div", __assign({}, newProps, { ref: ref })));
});
HoverableWrapper.displayName = 'HoverableWrapper';
export default HoverableWrapper;
//# sourceMappingURL=HoverableWrapper.js.map